//正则
export default {
  // 帐号
  account: /^\w{6,16}$/,
  // 密码
  // password:/^(?![0-9]+$)(?![a-zA-Z]+$)[(0-9A-Za-z)|(!@#$%^&*()_+=)]+$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)[(0-9A-Za-z)|(\s\S*)]+$/,
  // 邮箱
  email: /^((?=[a-zA-Z0-9])[a-zA-Z0-9._-]+)?[a-zA-Z0-9]{1}@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,}){1}$/,
  // 郵箱或用戶名
  account_email: /^(\w{6,16}|(((?=[a-zA-Z0-9])[a-zA-Z0-9._-]+)?[a-zA-Z0-9]{1}@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,}){1}))$/,
  // 驗證碼
  code: /^[a-zA-Z0-9]{4}$/,
  // 整型
  int: /^\d+$/,
  // 域名
  domainName: /^[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z]{2,}){1,2}$/,
  // 大陆手机
  cnPhone: /^1\d{10}$/,
  // 香港手机
  hkPhone: /^\d{8}$/,
  isPath: /^\/\S{0,50}?$/
}
